import adSlide1 from "./ad1.jpg";
import adSlide2 from "./ad2.jpg";
import adSlide3 from "./ad3.jpg";
import addDetail from "./addDetail.svg";
import addFilled from "./addFilled.svg";
import arrowUp from "./arrowUp.svg";
import autocompleteExitIcon from "./autocompleteExit.svg";
import call from "./call.svg";
import changePassword from "./changePassword.svg";
import checkMark from "./checkmark.svg";
import checkMarkOL from "./checkmarkOutline.svg";
import close from "./close.svg";
import deleteDetail from "./deleteDetail.svg";
import digicoin from "./digicoin.svg";
import digisaarthiLogo from "./digisaarthi.svg";
import downIndicator from "./downIndicator.svg";
import emptyMedicine from "./emptyMedicine.svg";
import errorIcon from "./errorIcon.svg";
import patientIcon from "./faceDark.svg";
import filter from "./filter.svg";
import gstr1 from "./gstr1.svg";
import gstr2 from "./gstr2.svg";
import hash from "./hash.svg";
import help from "./help.svg";
import infoIcon from "./infoIcon.svg";
import kebabMenu from "./kebabMenu.svg";
import locked from "./locked.svg";
import LoginScreen01 from "./LoginScreen01.jpg";
import LoginScreen02 from "./LoginScreen02.jpg";
import logout from "./logout.svg";
import medicineWithBackground from "./medicineWithBackground.svg";
import message from "./message.svg";
import newPatient from "./newPatient.svg";
import noDataAvailable from "./noDataAvailable.svg";
import newDistributor from "./noDistributor.svg";
import noMedicine from "./noMedicine.svg";
import noprescriptions from "./noprescriptions.svg";
import notFound from "./notFound.svg";
import notifications from "./notifications.svg";
import editIcon from "./pencil.svg";
import appLogo from "./pharmacyProLogo.svg";
import promiseIcon from "./promiseIcon.svg";
import redoIcon from "./redoIcon.svg";
import sadIcon from "./sadIcon.svg";
import searchIcon from "./search.svg";
import settingsIcon from "./settingsIcon.svg";
import spotlight from "./spotlight.svg";
import doctorIcon from "./stethoscope.svg";
import stethoscopeWithBackground from "./stethoscopeWithBackground.svg";
import successIcon from "./successIcon.svg";
import support from "./support.svg";
import warningIcon from "./warningIcon.svg";
import welcomeCarousel1 from "./welcomeCarousel1.jpg";
import welcomeCarousel2 from "./welcomeCarousel2.jpg";
import welcomeCarousel3 from "./welcomeCarousel3.jpg";
import welcomeCarouselUpdated1 from "./welcomeCarouselUpdated1.jpg";
import welcomeCarouselUpdated2 from "./welcomeCarouselUpdated2.jpg";
import youtubeIcon from "./youtubeIcon.svg";

const images = {
  patientIcon,
  doctorIcon,
  editIcon,
  searchIcon,
  checkMark,
  checkMarkOL,
  autocompleteExitIcon,
  sadIcon,
  downIndicator,
  emptyMedicine,
  digicoin,
  youtubeIcon,
  addDetail,
  deleteDetail,
  infoIcon,
  promiseIcon,
  redoIcon,
  noDataAvailable,
  newPatient,
  noMedicine,
  medicineWithBackground,
  stethoscopeWithBackground,
  hash,
  close,
  newDistributor,
  addFilled,
  errorIcon,
  successIcon,
  warningIcon,
  spotlight,
  welcomeCarousel1,
  welcomeCarousel2,
  welcomeCarousel3,
  appLogo: appLogo,
  digisaarthiLogo,
  kebabMenu,
  message,
  support,
  call,
  notifications,
  notFound,
  filter,
  locked,
  logout,
  arrowUp,
  settingsIcon,
  help,
  noprescriptions,
  adSlide1,
  adSlide2,
  adSlide3,
  gstr1,
  gstr2,
  welcomeCarouselUpdated1,
  welcomeCarouselUpdated2,
  LoginScreen02,
  LoginScreen01,
  changePassword,
};
export default images;
